let config;

config = {
   // api_url: "https://localhost:7043/api/v1/",
    api_url: "https://dc-stg-cct-api-dr.dc68032.easn.morningstar.com/api/v1/",
    audioFileType:".mp3,.mp4",
    pptFileType:".pdf,.ppt",
    transcriptFileType:".pdf,.doc,.docx",
    alertTime:5, // seconds
    ffPriorityList: "FF1,FF2,FF3" ,
  };

  export default config;